module.exports = __webpack_public_path__ + "media/images/health-system-81678e3db394e8edcf047ce935c3af74.svg";